import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { Constants } from '../../../constants';
import { AppConfigService } from '../../services/app-config.service';
import { UserInfo } from '../../../userInfo';
import { SBHttpServicesService } from '../../../shared/services/sbhttp-services.service';
import { Languges } from '../../../Languages';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { SharedHandlersService } from '../../../shared/shared-handlers.service';
import { IControls, IDropDown } from 'BI-Libraries/BI-Interfaces/dist/bi-interfaces';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ControlTypes } from 'BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/lib/enums/ControlTypes';
import { HttpService } from 'src/app/shared/services/HttpClientServices/Http.service';
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, AfterViewInit {
    SalesmenList: any[];
    @ViewChild('FunctionList') FunctionListRef!: IDropDown;
    @ViewChild('mySelect') mySelect: ElementRef;
    dashboardValues: any;
    dashboards: any[] = [];
    TargetBar = [];
    barChart: any[] = [];
    barChartNames = [];
    userData: string = "";
    UserInfo: any;
    data
    FormGroup: any
    public FilterControl: IControls[] = [];

    constructor(private httpService: SBHttpServicesService, public httpClientService: HttpService, private environment: AppConfigService
        , private lang: Languges, private toastr: ToastrService, private cd: ChangeDetectorRef, private Shared: SharedHandlersService, public translateService: TranslateService) {
        this.FilterControl = this.getSalesmanListControl();

    }

    ngOnInit() {
        this.UserInfo = JSON.parse(localStorage.getItem('userinfo'));
        this.barChartNames = [];
        this.barChart = [];
        this.userData == "" ? (this.userData = UserInfo.CurrentSalesmanNo) : (this.userData = this.userData);
        this.FormGroup = new FormGroup({
            Salesman: new FormControl(this.UserInfo.UserCode)
        })
        this.getSalesmenList();
    }
    async ngAfterViewInit() {
        await this.calculateTargets(this.UserInfo.UserCode);
        this.data = this.UserInfo.UserCode;

    }

    getName(key: string): string {
        return this.Shared.getName(key);
    }

    public onChangeBarChart(event, index): void {

        let TargetId = event.target.value;
        let Target = this.TargetBar.find(target => target.id == TargetId);
        this.barChart = [Target.prev ? Target.prev : 0, Target.curr ? Target.curr : 0];
    }

    gettargetname(target: any) {
        var targetName = "";
        var language = this.UserInfo.Language;
        targetName = language == 2 ? target.TargetNameE : target.TargetNameA;
        return targetName
    }
    async getTargets(salesmanNo) {
        this.dashboards = [];
        var url = `${this.environment.oDataApi}/api/Target/GetTargetBySalesmanNO/${salesmanNo}`
        this.dashboardValues = await this.httpService.httpGetRequest(url);

    }
    getSalesmenList() {
        this.FilterControl.map(control => {
            this.httpClientService.get(`SupervisorWithSubordinat/${this.UserInfo.UserCode}`).subscribe((data) => {
                data.forEach((item) => {
                    control.dropDownTemplate.list.push({ text: item.NameE, code: item.ID });
                });
            });

        })
    }

    async calculateTargets(salesmanNo) {
        await this.getTargets(salesmanNo)
        this.barChartNames = [];
        this.TargetBar = []
        this.dashboardValues.forEach(x => {

            var Achevied = x.TargetActual.toFixed(2);
            var ToTarget = x.TargetValue.toFixed(2);

            this.dashboards.push([{
                kind: "" + this.getName("Achevied") + " - " + Achevied, share: Achevied, name: this.gettargetname(x), colorField: "#d7481f"
            }, {
                kind: "" + this.getName("To Target") + " - " + ToTarget, share: ToTarget, name: this.gettargetname(x), colorField: "lightgrey", percentage: ToTarget == 0 ? 0 : Math.round((+Achevied / +ToTarget) * 100)
            }]);

            this.barChartNames.push(this.gettargetname(x));
            this.TargetBar.push({ id: x.id, prev: x.PrevTargetActual, curr: x.TargetActual })
        });
        console.log(this.dashboardValues[0]['id']);
        this.setSelectValue(this.dashboardValues[0]['id']);
    }
    OnSelectSalesman(action: any) {
        this.calculateTargets(action.code);
    }


    setSelectValue(value: any) {
        let TargetId = value;
        let Target = this.TargetBar.find(target => target.id == TargetId);
        this.barChart = [Target.prev ? Target.prev : 0, Target.curr ? Target.curr : 0];
    }


    getSalesmanListControl() {
        var userCode = JSON.parse(localStorage.getItem('userinfo'))?.UserCode;
        return ([
            {
                colNumber: 1,
                rowNumber: 1,
                DisplayName: "Salesman",
                DomID: "Col_Salesman",
                Name: "Salesman",
                controlType: ControlTypes.Select,
                IsEditable: false,
                DefaultValue: 2,
                IsVisible: true,
                dropDownTemplate: {
                    value: 'code',
                    text: 'text',
                    list: [
                        { text: 'All', code: userCode }],
                    OnselectionChange: (event) => this.OnSelectSalesman(event)
                }
            }]);
    }


}
